import { render } from "./ProfileCardHeader.vue?vue&type=template&id=2c54813e&scoped=true"
import script from "./ProfileCardHeader.vue?vue&type=script&lang=js"
export * from "./ProfileCardHeader.vue?vue&type=script&lang=js"

import "./ProfileCardHeader.vue?vue&type=style&index=0&id=2c54813e&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c54813e"]])

export default __exports__